import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions from "../../AxiosActions";
import { ExportGridIdentifier } from "../../../../utils/appEnums/AppEnums";

interface ExportGridDataDTO {
    filterBy: { key: string; value: string; operator: string }[];
    orderBy: { key: string; order: string }[];
}

export const runExportGridDataProcess = (
    identifier: `${ExportGridIdentifier}`,
    fileName: string | undefined,
    dto: ExportGridDataDTO,
    config: AxiosRequestConfig,
    spinner = false,
): Promise<AxiosResponse> => {
    const baseUrl = `/health/grid/export/run?identifier=${encodeURIComponent(identifier)}`;
    const url = fileName ? `${baseUrl}&fileName=${encodeURIComponent(fileName)}` : baseUrl;

    return AxiosActions.post(getAxiosInstances().V3, url, dto, config, spinner);
};
